import gql from 'graphql-tag'
import { BoUsersFragment } from '../../types/BoUserWithFeaturesInfoFragment'

export const BO_USERS_F = gql<BoUsersFragment>`
  fragment BoUsersFragment on User {
    id
    firstName
    lastName
    email
    created
    changed
    isVerified
    role
    accountId
    hasTwoFactorAuthenticationEnabled
    subscriptionPlan
    subscriptionStatus
    trialEnd
    qty
    cirrusStandardQty
    stripeSubscriptionId
    cellularSubscriptionStatus
    cellularStripeSubscriptionId
    analyticsSubscriptionPlan
    analyticsSubscriptionStatus
    analyticsStripeSubscriptionId
    analyticsQty
    analyticsStandardQty
    analyticsFreeFromAdminEnd
    displayFreeFromAdminEnd
    paymentProvider
    activeFeatureGrants {
      id
      featureKey
      startsAt
      expiresAt
      daysRemaining
      note
    }
  }
`
